(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 jQuery('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-feed"] && !Shopify.designMode) return;
  try {
    
   var userFeed = new Instafeed({
    get: 'user',
    userId: '246038629',
    clientId: 'de0d860002824dfb999110aba4706306',
    accessToken: '246038629.1677ed0.fc2ae4ed938540c6b1bf28ec35ab750e',
    resolution: 'standard_resolution',
    template: '<a class="insta-image col-sm-6 col-md-3" target="_blank" href="{{link}}"><img src="{{image}}"></a>',
    sortBy: 'most-recent',
    limit: 4,
    links: false
  });
  userFeed.run();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-form"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {

	var cookieValue = Cookies.get('NutraMCSubscribed');
	var popupClosed = Cookies.get('NutraMCPopupClosed');
	if(cookieValue !== 'true' && popupClosed !== 'true'){
		setTimeout(function() {
			$('#shopify-section-signup-form').addClass('active');
		}, 5000);
	}

	$('.close-signup').on('click', function(e){
		$('#shopify-section-signup-form').removeClass('active');
		Cookies.set('NutraMCPopupClosed', 'true', { expires: 365 });
	});

	$('input.email').blur(function(){
		if($(this).val().length > 0) {
			$('.no-label').addClass('valid').removeClass('empty');
		} else {
			$('.no-label').addClass('empty').removeClass('valid');
		}
	});

	$('.button').on('click', function(){
		$('.mc-label').css({
			'display': 'block'
		})
	})

	$('label.no-label').on('click', function(){
		$('#mce-EMAIL').focus();
	});

	function onChimpSuccess (resp) {
    if (resp.result === 'success') {
        	Cookies.set('NutraMCSubscribed', 'true');
			Cookies.set('NutraMCPopupClosed', 'true', { expires: 365 });
        	setTimeout(function(){
        		$('#shopify-section-signup-form').removeClass('active');
        	}, 5000);
			$('.email').removeClass('submitting');
    	} else if (resp.msg.includes('already subscribed')){
    		Cookies.set('NutraMCSubscribed', 'true');
    		setTimeout(function(){
        		$('#shopify-section-signup-form').removeClass('active');
        	}, 5000);
    	}
	}

	$('#mc-embedded-subscribe-form-1,#mc-embedded-subscribe-form-2').ajaxChimp({
		callback: onChimpSuccess
	})
});

  } catch(e) { console.error(e); }
})();
})();
